module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-content"
  }, [_c('section', [_c('h2', {
    staticClass: "md-headline"
  }, [_vm._v("Hmmm. Too bad")]), _vm._v(" "), _c('p', [_vm._v("Are you searching for a new component? Or maybe you have an question? Get in touch!")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "href": "mailto:marcosvmmoura@gmail.com?Subject=Vue%20Material%20-%20Question",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "href": "https://github.com/marcosmoura/vue-material/issues/new",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("New Issue")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-126169c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error.vue
// module id = 524
// module chunks = 83